import React, { useMemo } from 'react';
import { Company } from '../../../types/company';
import { FileViewLoader } from '../../../VentoryUI/components/common/File';
import { FileEntityType } from '../../../types/file';
import { ReactComponent as VentoryWhiteLogo } from '../../../assets/img/Ventory-WhiteNoBack.svg';
import { VentoryColor } from '../../../VentoryUI/util/color.util';
import { Icon } from '../../icons';
import { IconType } from '../../icons/Icon';
import { Card } from '../Card';

interface CompanyCardProps {
  company: Company;
  onClick: () => void;
}

export default function CompanyCard({ company, onClick }: CompanyCardProps) {
  const logoClassName = 'object-scale-down';

  const logo = useMemo(() => {
    if (company.settings.companyLogo) {
      return (
        <FileViewLoader
          className={logoClassName}
          companyId={company.id}
          fileId={company.settings.companyLogo}
          fileEntityType={FileEntityType.company}
        />
      );
    } else {
      return <VentoryWhiteLogo className={logoClassName} color={VentoryColor.grey500} stroke={VentoryColor.grey500} />;
    }
  }, [company]);

  return (
    <Card size='lg' onClick={onClick}>
      <div className='flex w-full flex-col items-center justify-center gap-2'>
        <div
          className={`flex h-12 w-full items-center justify-center`}
          style={{ backgroundColor: company.settings.headerColor }}
        >
          {logo}
        </div>

        <p className='w-full break-words text-center font-medium text-black'>{company.name}</p>
        {company.partner && <Icon type={IconType.dataFlow4} size={'size-5'} stroke='stroke-current' />}
      </div>
    </Card>
  );
}
